import { Check } from 'lucide-react'
import { labelCls } from '../styles'
import { ENVIRONMENTS } from '../data'
import type { EnvId } from '../types'

interface EnvironmentSelectorProps {
  selected: EnvId[]
  onChange: (envs: EnvId[]) => void
  disabled?: boolean
}

export function EnvironmentSelector({ selected, onChange, disabled }: EnvironmentSelectorProps) {
  function toggle(id: EnvId) {
    onChange(selected.includes(id) ? selected.filter((e) => e !== id) : [...selected, id])
  }

  return (
    <div>
      <label className={labelCls}>Environments to provision</label>
      <div className="flex flex-wrap gap-2">
        {ENVIRONMENTS.map((env) => {
          const checked = selected.includes(env.id)
          return (
            <button
              key={env.id}
              type="button"
              onClick={() => toggle(env.id)}
              disabled={disabled}
              className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-[7px] text-[11px] font-semibold uppercase tracking-wide transition-colors disabled:opacity-40"
              style={checked
                ? { background: '#eef2ff', border: '1px solid #6366f1', color: '#4f46e5' }
                : { background: '#f8fafc', border: '1px solid #e5e7eb', color: '#64748b' }
              }
            >
              <span
                className="w-3.5 h-3.5 rounded-[4px] flex items-center justify-center shrink-0"
                style={checked ? { background: '#6366f1' } : { background: '#ffffff', border: '1px solid #cbd5e1' }}
              >
                {checked && <Check size={10} className="text-white" strokeWidth={3} />}
              </span>
              {env.label}
            </button>
          )
        })}
      </div>
    </div>
  )
}
